"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.page = void 0;
var React = require("react");
var react_redux_1 = require("react-redux");
var redux_1 = require("redux");
var Pages_1 = require("@/rendering/common/Pages");
var InvestorAction_1 = require("@/pages/investor/actions/InvestorAction");
var AboutPage_1 = require("@/pages/common/components/AboutPage");
var peopleListingStyles_1 = require("@/pages/peopleListing/components/peopleListingStyles");
var recompose_1 = require("recompose");
var core_1 = require("@material-ui/core");
var PeopleSearch_1 = require("@/pages/peopleListing/components/PeopleSearch/PeopleSearch");
var PeopleListingContainer_1 = require("@/pages/peopleListing/components/PeopleListingContainer/PeopleListingContainer");
var ServerSideSchema_1 = require("@/pages/common/components/schema/ServerSideSchema");
var mapStateToProps = function (state) { return (__assign(__assign({}, state), { menu: state.layout.menulist.filter(function (it) { return it.page === Pages_1.Pages.ABOUT; })[0] })); };
var mapDispatchToProps = function (dispatch) { return ({
    onInvestorSubmit: function (enquiry) { return dispatch(InvestorAction_1.default.onInvestorSubmit(enquiry)); },
}); };
exports.page = function (props) {
    var headerSection = props.headerSection, searchOptionSection = props.searchOptionSection, searchedPeoples = props.searchedPeoples, layout = props.layout, nameFilter = props.nameFilter, setNameFilter = props.setNameFilter, languageFilter = props.languageFilter, setLanguageFilter = props.setLanguageFilter, page = props.page, showSearch = props.showSearch, showJoin = props.showJoin;
    var careerUrl = layout.careerUrl, language = layout.language;
    var langCode = language.languages.filter(function (it) { return it.id === language.current; })[0].code1;
    var headStyle = {
        backgroundImage: 'url(/res/img/skyline_hk.jpg)',
        backgroundSize: 'center 23%',
        backgroundAttachment: 'unset',
    };
    var containerStyle = {
        overflowX: 'hidden',
    };
    var containerClass = 'c-ssection__block c-ssection__block--noflex l-container__mfull';
    var peoples = searchedPeoples.items.filter(function (item) {
        var nameMatch = true;
        var languageMatch = true;
        if (nameFilter !== '') {
            nameMatch = item.fullName.toLowerCase().includes(nameFilter.toLowerCase());
        }
        if (languageFilter > 0) {
            languageMatch = item.spokenLanguagesIds.includes(languageFilter);
        }
        return nameMatch && languageMatch;
    });
    var renderSearchBar = function () {
        return showSearch ? (React.createElement(PeopleSearch_1.PeopleSearch, { nameFilter: nameFilter, setNameFilter: setNameFilter, languageFilter: languageFilter, setLanguageFilter: setLanguageFilter, spokenLanguageOptions: searchOptionSection.spokenLanguageOptions, showLabel: true, t: searchOptionSection.translate })) : null;
    };
    var renderMobileSearchBar = function () {
        return showSearch ? (React.createElement(PeopleSearch_1.MobilePeopleSearch, { nameFilter: nameFilter, setNameFilter: setNameFilter, languageFilter: languageFilter, setLanguageFilter: setLanguageFilter, spokenLanguageOptions: searchOptionSection.spokenLanguageOptions, showLabel: false, t: searchOptionSection.translate })) : null;
    };
    return (React.createElement(AboutPage_1.default, { title: headerSection.translate.header, headStyle: headStyle, currentPage: page, menu: props.menu },
        React.createElement("div", { className: "c-ssection c-ssection--simple" },
            React.createElement(core_1.Hidden, { xsDown: true },
                React.createElement("h2", { className: "c-ssection__title" }, headerSection.translate.title)),
            React.createElement("div", { className: containerClass, style: containerStyle },
                React.createElement(peopleListingStyles_1.Header, { className: "c-page-header", style: { marginBottom: 0 } },
                    React.createElement("div", { className: "c-page-header__body" },
                        React.createElement("span", null, headerSection.translate.content))),
                React.createElement(core_1.Hidden, { mdUp: true },
                    renderMobileSearchBar(),
                    React.createElement(core_1.Hidden, { smUp: true },
                        React.createElement(peopleListingStyles_1.OurPropertyAgentsText, null, headerSection.translate.title)),
                    React.createElement(core_1.Hidden, { xsDown: true },
                        React.createElement("div", { style: { height: 20 } })),
                    React.createElement(PeopleListingContainer_1.MobilePeopleListingContainer, { peoples: peoples, langCode: langCode, careerUrl: careerUrl, showJoin: showJoin, t: searchedPeoples.translate })),
                React.createElement(core_1.Hidden, { smDown: true },
                    renderSearchBar(),
                    React.createElement(peopleListingStyles_1.OurPropertyAgentsText, null, searchedPeoples.translate.ourPropertyAgents),
                    React.createElement(PeopleListingContainer_1.PeopleListingContainer, { peoples: peoples, langCode: langCode, careerUrl: careerUrl, showJoin: showJoin, t: searchedPeoples.translate })))),
        React.createElement(ServerSideSchema_1.default, null)));
};
var enhance = redux_1.compose(react_redux_1.connect(mapStateToProps, mapDispatchToProps), recompose_1.withState('nameFilter', 'setNameFilter', ''), recompose_1.withState('languageFilter', 'setLanguageFilter', 0));
exports.default = enhance(exports.page);
